import { __module as t } from "../../../_virtual/isDataURI.js";
import { a as r } from "./util/assertString.js";
Object.defineProperty(e = t.exports, "__esModule", {
  value: !0
}), e.default = function (t) {
  (0, a.default)(t);
  var r = t.split(",");
  if (r.length < 2) return !1;
  var e = r.shift().trim().split(";"),
    f = e.shift();
  if ("data:" !== f.substr(0, 5)) return !1;
  var o = f.substr(5);
  if ("" !== o && !s.test(o)) return !1;
  for (var l = 0; l < e.length; l++) if (!(l === e.length - 1 && "base64" === e[l].toLowerCase()) && !i.test(e[l])) return !1;
  for (var n = 0; n < r.length; n++) if (!u.test(r[n])) return !1;
  return !0;
}, a = r && r.__esModule ? r : {
  default: r
}, s = /^[a-z]+\/[a-z0-9\-\+]+$/i, i = /^[a-z\-]+=[a-z0-9\-]+$/i, u = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i, t.exports = e.default, t.exports.default = e.default;
var e,
  a,
  s,
  i,
  u,
  f = t.exports;
export { f as i };